import React from 'react';
import { motion } from 'framer-motion';
import { CreditCard, Upload, MessageSquare, Plus, FileText, ShieldCheck, BarChart2, Award, Calendar, Wrench, FileSignature, PieChart, FolderKanban } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
export function QuickActions() {
  const {
    user
  } = useAuth();
  const navigate = useNavigate();
  if (!user) return null;
  const getActions = () => {
    switch (user.role) {
      case 'tenant':
        return [{
          name: 'Pay Rent',
          icon: CreditCard,
          color: 'bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400',
          path: '/tenant/payment-schedule'
        }, {
          name: 'Certificate',
          icon: Award,
          color: 'bg-green-100 text-green-600 dark:bg-green-900/30 dark:text-green-400',
          path: '/tenant/certificate'
        }, {
          name: 'Rent History',
          icon: BarChart2,
          color: 'bg-purple-100 text-purple-600 dark:bg-purple-900/30 dark:text-purple-400',
          path: '/tenant/rent-history'
        }, {
          name: 'Flexibility',
          icon: Calendar,
          color: 'bg-orange-100 text-orange-600 dark:bg-orange-900/30 dark:text-orange-400',
          path: '/tenant/payment-flexibility'
        }, {
          name: 'Maintenance',
          icon: Wrench,
          color: 'bg-red-100 text-red-600 dark:bg-red-900/30 dark:text-red-400',
          path: '/tenant/maintenance'
        }, {
          name: 'Documents',
          icon: Upload,
          color: 'bg-indigo-100 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400',
          path: '/tenant/documents'
        }];
      case 'landlord':
        return [{
          name: 'Portfolio',
          icon: PieChart,
          color: 'bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400',
          path: '/landlord/portfolio'
        }, {
          name: 'Add Property',
          icon: Plus,
          color: 'bg-green-100 text-green-600 dark:bg-green-900/30 dark:text-green-400',
          path: '/landlord/properties'
        }, {
          name: 'Lease Gen',
          icon: FileSignature,
          color: 'bg-purple-100 text-purple-600 dark:bg-purple-900/30 dark:text-purple-400',
          path: '/landlord/lease-generator'
        }, {
          name: 'Applications',
          icon: FolderKanban,
          color: 'bg-orange-100 text-orange-600 dark:bg-orange-900/30 dark:text-orange-400',
          path: '/landlord/applications'
        }, {
          name: 'Settlements',
          icon: FileText,
          color: 'bg-indigo-100 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-400',
          path: '/landlord/dashboard'
        }, {
          name: 'Support',
          icon: MessageSquare,
          color: 'bg-pink-100 text-pink-600 dark:bg-pink-900/30 dark:text-pink-400',
          path: '/help'
        }];
      case 'admin':
        return [{
          name: 'Verify Tenant',
          icon: ShieldCheck,
          color: 'bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400',
          path: '/admin/verification'
        }, {
          name: 'Run Report',
          icon: BarChart2,
          color: 'bg-purple-100 text-purple-600 dark:bg-purple-900/30 dark:text-purple-400',
          path: '/admin/analytics'
        }, {
          name: 'View Alerts',
          icon: MessageSquare,
          color: 'bg-red-100 text-red-600 dark:bg-red-900/30 dark:text-red-400',
          path: '/admin/dashboard'
        }];
      default:
        return [];
    }
  };
  const actions = getActions();
  return <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-6 transition-colors" data-id="element-2507">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 truncate" data-id="element-2508">
        Quick Actions
      </h3>
      <div className="grid grid-cols-3 gap-3" data-id="element-2509">
        {actions.map(action => <motion.button key={action.name} onClick={() => navigate(action.path)} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="flex flex-col items-center justify-center p-3 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors" data-id="element-2510">
            <div className={`h-10 w-10 rounded-full flex items-center justify-center mb-2 flex-shrink-0 ${action.color}`} data-id="element-2511">
              <action.icon className="h-5 w-5" data-id="element-2512" />
            </div>
            <span className="text-xs font-medium text-gray-700 dark:text-gray-300 text-center line-clamp-2 w-full" data-id="element-2513">
              {action.name}
            </span>
          </motion.button>)}
      </div>
    </div>;
}